import React, { useEffect, useState } from "react";
import { Backdrop, CircularProgress, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { getItemDetails } from "../apiCalls";
import CartSummary from "../cartDialogComponents/cartSummary";

export default function OrderSummaryDialog({
  orderSummaryVisible,
  setOrderSummaryVisibility,
  requestId,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const response = await getItemDetails(requestId);
      setCartItems(response);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  return (
    <Dialog
      open={orderSummaryVisible}
      onClose={() => setOrderSummaryVisibility(false)}
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogContent>
        {isLoading && (
          <Backdrop sx={{ color: "#fff", zIndex: 99999 }} open={isLoading}>
            <CircularProgress />
          </Backdrop>
        )}
        <CartSummary cartItems={cartItems} walletAmount={-1} closeIconShow={true} setOrderSummaryVisibility={setOrderSummaryVisibility}/>
      </DialogContent>
    </Dialog>
  );
}
